<template>
    <div class="page">
        <van-nav-bar
            title="详情"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="contents" v-if="!isEmpty(detail)">
            <div class="tit">
                <p class="f-fs16 f-fwb">{{detail.pro}}丨{{detail.projectName}}</p>
                <p class="f-fs14 mt-10">{{detail.statusName}}</p>
            </div>
            <div class="b1" data-flex="cross:center">
                <img class="icon" data-flex-box="0" :src="detail.fansAvatarUrl"
                    mode="aspectFill" />
                <div class="ml-20" data-flex-box="1" data-flex="dir:top main:justify">
                    <p class="f-fs16 f-fwb">{{detail.name}}</p>
                    <p class="f-fs14">{{detail.addressFull}}</p>
                </div>
            </div>
            <div class="b2">
                <div class="t1">服务团队</div>
                <div data-flex="cross:center" class="mt-20">
                    <div class="list" v-for="item in detail.businessList">
                        <img class="icon" data-flex-box="0" :src="item.avatarUrl"
                            mode="aspectFill" />
                        <p class="f-fs14 mt-5">{{item.realname}}</p>
                        <p class="f-fs14 mt-5">业务员</p>
                    </div>
                    <div class="list" v-for="item in detail.supervisorList">
                        <img class="icon" data-flex-box="0" :src="item.avatarUrl"
                            mode="aspectFill" />
                        <p class="f-fs14 mt-5">{{item.realname}}</p>
                        <p class="f-fs14 mt-5">监理</p>
                    </div>
                    <div class="list" v-for="item in detail.stylistList">
                        <img class="icon" data-flex-box="0" :src="item.avatarUrl"
                            mode="aspectFill" />
                        <p class="f-fs14 mt-5">{{item.realname}}</p>
                        <p class="f-fs14 mt-5">设计</p>
                    </div>
                    <div class="list" v-for="item in detail.craftsmanList">
                        <img class="icon" data-flex-box="0" :src="item.avatarUrl"
                            mode="aspectFill" />
                        <p class="f-fs14 mt-5">{{item.realname}}</p>
                        <p class="f-fs14 mt-5">工匠</p>
                    </div>
                </div>
            </div>
            <div class="b3">
                <div class="tit_box mb-20" data-flex="cross:center">
                    <div class="t1" data-flex-box="1">工地动态</div>
                    <!-- <div data-flex="cross:center" data-flex-box="0">
                        <p class="f-fs14 ml-10" v-for="item in tabList" @click="onTab(item)" :class="{on: item.id == tabIndex}">{{item.name}}</p>
                    </div> -->
                </div>
                <div class="itme_box" v-if="!isEmpty(detail.allLogsList)">
                    <div class="item" v-for="it in detail.allLogsList">
                        <div class="info" data-flex="cross:center main:justify">
                            <img class="icon" data-flex-box="0" :src="it.memberInfo.avatarUrl"
                                mode="aspectFill" />
                            <div class="ml-20" data-flex-box="1" data-flex="dir:top main:justify">
                                <p class="f-fs14"><span>{{it.memberInfo.realname}}</span><span class="ml-10">工匠</span></p>
                                <p class="f-fs14">{{it.ctime}}</p>
                            </div>
                        </div>
                        <div class="description">{{it.title}}</div>
                        <div class="img_box">
                            <img class="icon" data-flex-box="0" v-for="(img, imgIndex) in it.otherImages" :src="img | qiniuImageView(1, 120, 120)"
                              mode="aspectFill"  @click="showImg(img)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-overlay :show="show" @click="show = false">
            <div class="wrapper">
                <img class="icon" data-flex-box="0" :src="showImgUrl | qiniuResource"
                    mode="aspectFill" />
            </div>
        </van-overlay>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, Tab, Tabs, Progress, Empty, NavBar, ImagePreview, Overlay  } from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
    mixins: [mix1],
    components: {
        MgPopup,
        [Overlay.name]: Overlay,
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Progress.name]: Progress,
        [Empty.name]: Empty,

    },
    data() {
        return {
            show: false,
            showImgUrl: '',
            tabList: [
                {name: '最新汇报', id: 0},
                {name: '节点顺序', id: 1},
            ],
            tabIndex: 0,
            searchForm: {
                id: 0,
            },
            detail: {},
            logsList: []
        }
    },
    methods: {
        onClickLeft(){
            this.$router.go(-1);
        },
        onTab(item){
            this.tabIndex = item.id
        },
        toUrl(url) {
            this.$router.push(url)
        },
        showImg(url){
            console.log('url', url)
            this.showImgUrl = url
            this.show = true
            // ImagePreview({
            //     images: [
            //         'https://img01.yzcdn.cn/vant/apple-1.jpg',
            //         'https://img01.yzcdn.cn/vant/apple-2.jpg',
            //     ],
            //     startPosition: 1,
            // });
        },
        async loadData() {

            uiShowLoading()
            await delayAsync(500)

            const promise = this.apiGet('bi.work.orders.detail', this.searchForm)

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }
            this.isDataLoaded = true
            this.detail = apiResult.obj
            this.logsList = apiResult.list
            // this.asyncTile(apiResult.obj.title)
        },
    },
    mounted() {

    },
    created() {
        let query = this.$route.query
        this.searchForm.id = query.id
        this.loadData()
    }
}
</script>

<style lang="less">
.rd {
    .van-progress {
        width: 200px;
    }
}

.van-empty__image {
    width: 500px;
    height: 500px;
}
</style>
<style lang="less" scoped>
.page {
    background: #06385E;
    position: relative;
    min-height: calc(100vh);
    box-sizing: border-box;
    color: #fff;
    .contents{
        padding: 30px 50px;
        box-sizing: border-box;
        .tit{
            border-bottom: solid 1px #658197;
            padding-bottom: 20px;
        }
        .b1,
        .b2,
        .b3{
            padding: 20px 0;
            box-sizing: border-box;
            .t1{
                font-weight: bold;
                font-size: 16px;
            }
            .tit_box{
                div:nth-child(2){
                    color: #949494;
                    cursor: pointer;
                    .on{
                        color: #fff;
                    }
                }
            }
        }
        .b1{
            img{
                width: 40px;
                height: 40px;
                border-radius: 100px;
            }
            div{
                height: 36px;
            }
        }
        .b2{
            .list{
                text-align: center;
                margin-right: 20px;
                img{
                    width: 40px;
                    height: 40px;
                    border-radius: 100px;
                }
            }
        }
        .b3{
            .itme_box {
                .item{
                    padding: 10px 0;
                    border-bottom: solid 1px #658197;
                    .info{
                        img{
                            width: 40px;
                            height: 40px;
                            border-radius: 100px;
                        }
                        div{
                            height: 36px;
                        }
                    }
                    .description{
                        padding-top: 20px;
                        font-size: 14px;
                    }
                    .img_box{
                        padding: 10px 0;
                        img{
                            display: inline-block;
                            width: 120px;
                            height: 120px;
                            margin: 5px;
                        }
                    }
                }
            }
        }
    }
}

/deep/ .van-nav-bar__arrow{
    font-size: 26px;
}
/deep/ .van-nav-bar{
    background: #06385E;
}
/deep/ .van-nav-bar__title{
    color: #fff !important;
    font-size: 16px;
    font-weight: bold;
}
/deep/ .van-nav-bar .van-icon{
    color: #fff;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    img{
        width: 200px;
    }
}

</style>